import { useBreakpointValue, UseBreakpointValueArgs, UseBreakpointValueReturn } from '../useBreakpointValue';

export function useBreakpointComponent(
    elements: UseBreakpointValueArgs<JSX.Element>
): UseBreakpointValueReturn<JSX.Element> {
    const element = useBreakpointValue(elements);
    return element;
}
